// ─── Connexion tierce (Google / Apple) ─────────────────────────────
// Sign in with Apple est OBLIGATOIRE dès qu'un fournisseur tiers existe
// (règle App Store 4.8) — les deux sont donc livrés ensemble.
//
// `require` protégé comme AdMob/RevenueCat (`pub/PubZone.js`,
// `forfaits/achatNatifService.js`) : un binaire pas encore migré (modules
// absents) ne doit jamais planter au chargement du bundle — les boutons
// correspondants restent simplement masqués (voir `EcranConnexion.js`).
import { Platform } from 'react-native';
import { GoogleAuthProvider, OAuthProvider, signInWithCredential } from 'firebase/auth';
import { auth } from '../firebase';

let GoogleSignin = null;
if (Platform.OS !== 'web') {
  try { GoogleSignin = require('@react-native-google-signin/google-signin').GoogleSignin; } catch { /* module absent : app pas encore migrée */ }
}
let AppleAuthentication = null;
if (Platform.OS === 'ios') {
  try { AppleAuthentication = require('expo-apple-authentication'); } catch { /* module absent */ }
}
let Crypto = null;
if (Platform.OS === 'ios') {
  try { Crypto = require('expo-crypto'); } catch { /* module absent */ }
}

export const connexionGoogleDisponible = () => !!GoogleSignin;
export const connexionAppleDisponible = () => !!AppleAuthentication;

let googleConfigure = false;
function configurerGoogle() {
  if (!GoogleSignin || googleConfigure) return;
  const webClientId = process.env.EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID;
  const iosClientId = process.env.EXPO_PUBLIC_GOOGLE_IOS_CLIENT_ID;
  if (!webClientId) return;
  GoogleSignin.configure({ webClientId, iosClientId });
  googleConfigure = true;
}

export async function connexionAvecGoogle() {
  if (!GoogleSignin) throw new Error('Google Sign-In indisponible sur cette plateforme.');
  configurerGoogle();
  await GoogleSignin.hasPlayServices();
  const { data } = await GoogleSignin.signIn();
  const credential = GoogleAuthProvider.credential(data?.idToken);
  return signInWithCredential(auth, credential);
}

export async function connexionAvecApple() {
  if (!AppleAuthentication) throw new Error('Sign in with Apple indisponible sur cette plateforme.');
  // Nonce anti-rejeu : Apple reçoit le hash, Firebase vérifie avec la valeur brute.
  const rawNonce = Math.random().toString(36).slice(2) + Date.now().toString(36);
  const hashedNonce = Crypto ? await Crypto.digestStringAsync(Crypto.CryptoDigestAlgorithm.SHA256, rawNonce) : undefined;
  const appleCredential = await AppleAuthentication.signInAsync({
    requestedScopes: [
      AppleAuthentication.AppleAuthenticationScope.FULL_NAME,
      AppleAuthentication.AppleAuthenticationScope.EMAIL,
    ],
    nonce: hashedNonce,
  });
  const provider = new OAuthProvider('apple.com');
  const credential = provider.credential({ idToken: appleCredential.identityToken, rawNonce });
  return signInWithCredential(auth, credential);
}
